import { FC } from 'react';
import { ButtonHide, ButtonOpen } from '#baseMenu/components';

const ContentControls: FC = () => (
  <>
    <ButtonOpen />
    <ButtonHide />
  </>
);

export { ContentControls };
